import { Component, OnInit } from '@angular/core';
import { Boat } from '../l_admin/boat.model';
import { Router } from '@angular/router';
import { BoatService } from '../services/boat.service';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { getBoatImageUrl } from '../utils/image-url.util';

@Component({
  selector: 'app-raja-ampat',
  templateUrl: './raja-ampat.component.html',
  styleUrls: ['./raja-ampat.component.css']
})
export class RajaAmpatComponent implements OnInit {
  boats: any[] = [];
  displayedBoats: Boat[] = [];
  filteredBoats: Boat[] = [];
  arrboat: any[] = [];

  displayedImages: any[] = [];
  loading = false;
  error: string | null = null;
  selectedBoat: any | null = null;
  tujuan: string = 'Raja Ampat';

  currentPage = 1;
  itemsPerPage = 6;

  constructor(private apiService: BoatService, private router: Router) {}



  ngOnInit(): void {
    this.displayedImages = [
      'ra-4.webp',
      'ra-2.webp',
      'ra-1.webp',
      'ra-3.webp',
      'ra-6.webp',
      'ra-5.webp'
    ];
    this.loadBoats();
  }

  loadBoats(): void {
    this.loading = true;
    this.error = null;

    this.apiService
      .getBoatByTujuan(this.tujuan, 'Boat Charter')
      .pipe(
        catchError((error) => {
          this.error = 'Failed to load boats. Please try again later.';
          console.error('Error loading boats:', error);
          return of({ data: [] }); // Mengembalikan array kosong jika terjadi error
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response) => {
        if (response && response.items) {

          // console.log(response.items);
          // Memfilter data berdasarkan kategori boat
          this.boats = response.items.filter(
            (boat: any) =>
              boat.ms_tujuans &&
              boat.ms_tujuans.some((tujuan: any) =>
                tujuan.tuj.toLowerCase().includes(this.tujuan.toLowerCase())
              )
          );
          this.filteredBoats = [...this.boats];
          this.updateDisplayedBoats();
          this.preloadCarouselImages();
        }
      });
  }

   preloadCarouselImages(): void {
      if (typeof window === 'undefined' || !document) return;

      // Ambil gambar pertama dari setiap boat
      this.filteredBoats.forEach(boat => {
        if (boat.ms_gambarkapals && boat.ms_gambarkapals.length > 0) {
          const firstImage = boat.ms_gambarkapals[0].gambar;
          const url = getBoatImageUrl(firstImage);

          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'image';
          link.href = url;
          document.head.appendChild(link);
        }
      });
    }

  getImageUrl(image: any): string {
    const imagePath = image;
    if (imagePath.startsWith('http') || imagePath.startsWith('/assets')) {
      return imagePath;
    }
    return '/assets/img/banner/' + imagePath;
  }

  getBoatImage(image: any): string {
    return getBoatImageUrl(image.gambar);
  }


  loadMore() {
    this.currentPage++;
    this.updateDisplayedBoats();
  }

  private updateDisplayedBoats() {
    const endIndex = this.currentPage * this.itemsPerPage;
    this.displayedBoats = this.filteredBoats.slice(0, endIndex);
  }

  navigateToDetail(slug: string) {
    this.router.navigate(['/detail-boat', slug], {
      queryParams: { destination: 'raja-ampat' },
    });
  }
}
